// src/modules/Upsell/instances/experiments/web_unify_upsell_second_screen__white_x.ts
import type { UpsellTemplateSchema, UpsellComponentsConfig } from '../@types/upsell-types'
import { mergeDeep } from '@/helpers/utils'
import giftModalCheckedLilacSvg from '@/assets/upsell/gift-modal-checked-lilac.svg'
import giftBgPng from '@/assets/upsell/gift-bg.png'

export default (schema: UpsellTemplateSchema): UpsellTemplateSchema =>
	mergeDeep(
		{ ...schema },
		{
			components: {
				UpsellHead: ({ ctx, $t }): UpsellComponentsConfig['UpsellHead'] => ({
					...schema.components.UpsellHead({ ctx, $t }),
					logoAlignment: 'left',
					compactSpacing: true,
				}),
				UpsellSteps: ({ ctx, $t }): UpsellComponentsConfig['UpsellSteps'] => ({
					...schema.components.UpsellSteps({ ctx, $t }),
					compactSpacing: true,
				}),
				UpsellSkipUnwrapModal: ({ ctx }): UpsellComponentsConfig['UpsellSkipUnwrapModal'] => ({
					show: ctx.visibleModal === 'UpsellSkipUnwrapModal',
					image: giftBgPng,
					buttonColor: 'dark',
				}),
				UpsellSkipAnimationModal: ({ $t, ctx }): UpsellComponentsConfig['UpsellSkipAnimationModal'] => ({
					...schema.components.UpsellSkipAnimationModal({ $t, ctx }),
					icon: giftModalCheckedLilacSvg,
					text: [
						$t('female_activity.pages.upsell.discount_modal.subtitle', { discount: 60 }),
						`<b>${$t('female_activity.pages.upsell.discount_modal.note', { price: ctx.product.otp.localizedPrice })}</b>`,
					].join('<br><br>'),
					showCloseButton: true,
					closeButtonOpaque: true,
					handleBackdropClicks: true,
					purchaseByClick: true,
				}),
			},
		},
	)
